import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

export const Footer = () => {
  const handleScrollTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer data-testid="footer" className="bg-[#1F2A44]" id="contact">
      {/* Footer Links */}
      <div className="container-peak py-10 lg:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <Link to="/" onClick={handleScrollTop}>
              <span className="font-['Cormorant_Garamond'] text-2xl lg:text-3xl text-[#F4F1EC]">
                Peak<span className="text-[#D97904]">9</span>
              </span>
            </Link>
            <p className="text-[#F4F1EC]/60 text-xs lg:text-sm mt-3 lg:mt-4 leading-relaxed">
              Engineering peak performance with well-being.
            </p>
            {/* Locations */}
            <div className="mt-4 lg:mt-6">
              <div className="flex items-start gap-2 text-[#F4F1EC]/50 text-xs lg:text-sm">
                <MapPin size={14} className="mt-0.5 flex-shrink-0 text-[#D97904]" />
                <div className="flex flex-col gap-0.5 lg:gap-1">
                  <span>Mumbai</span>
                  <span>Bangalore</span>
                  <span>Spain</span>
                </div>
              </div>
            </div>
          </div>

          {/* For Business */}
          <div>
            <h4 className="font-['Syne'] text-[10px] lg:text-xs uppercase tracking-[0.2em] text-[#D97904] mb-4 lg:mb-5">
              For Business
            </h4>
            <nav className="flex flex-col gap-2 lg:gap-3">
              <Link to="/keynotes" onClick={handleScrollTop} className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                Keynotes
              </Link>
              <Link to="/workshops" onClick={handleScrollTop} className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                Workshops & Training
              </Link>
              <Link to="/library" onClick={handleScrollTop} className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                Peak 9 Library
              </Link>
            </nav>
          </div>

          {/* For Coaches */}
          <div>
            <h4 className="font-['Syne'] text-[10px] lg:text-xs uppercase tracking-[0.2em] text-[#D97904] mb-4 lg:mb-5">
              For Coaches
            </h4>
            <nav className="flex flex-col gap-2 lg:gap-3">
              <Link to="/school" onClick={handleScrollTop} className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                School of Shayamal
              </Link>
            </nav>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-['Syne'] text-[10px] lg:text-xs uppercase tracking-[0.2em] text-[#D97904] mb-4 lg:mb-5">
              Company
            </h4>
            <nav className="flex flex-col gap-2 lg:gap-3">
              <Link to="/about" onClick={handleScrollTop} className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                About Us
              </Link>
              <Link to="/privacy-policy" onClick={handleScrollTop} data-testid="footer-privacy-link" className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" onClick={handleScrollTop} data-testid="footer-cookie-link" className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                Cookie Policy
              </Link>
              <Link to="/terms-and-conditions" onClick={handleScrollTop} data-testid="footer-terms-link" className="text-[#F4F1EC]/70 text-xs lg:text-sm hover:text-[#F4F1EC] transition-colors">
                Terms & Conditions
              </Link>
            </nav>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container-peak py-4 lg:py-6 border-t border-[#F4F1EC]/10">
        <p className="text-[#F4F1EC]/40 text-[10px] lg:text-xs text-center lg:text-left">
          © {new Date().getFullYear()} Peak 9. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
